import React, { Component } from 'react';
import OpenCollapsible from './OpenCollapsible';
import CloseCollapsible from './CloseCollapsible';
import IndicatorDropdown from './IndicatorDropdown';
import MapViewCollapsible from './MapViewCollapsible';
import BarChartCollapsible from './BarChartCollapsible';
import LineChartCollapsible from './LineChartCollapsible';
import TableCollapsible from './TableCollapsible';
import CountrySelector from './CountrySelector';
import Indicator from '../data/IndicatorValueMap';
import IndicatorModal from './IndicatorModal';
import { fetchData } from "../redux/StatsActions";
import Footer from './Footer';
import CountrySourcesCollapsible from './CountrySourcesCollapsible';
import SourcesCollapsible from './SourcesCollapsible';
import { getParams } from './Helper';
import { connect } from 'react-redux';
import { Icon, Row, Col, Button } from 'react-materialize'


class View extends Component {
  constructor(props){
    super(props);
    this.state = {
      collapsible: true,

      demographicSelected: false,
      demoValue: null,

      sedentarySelected: false,
      sedentaryValue: null,

      dietSelected: false,
      dietValue: null,

      tobaccoSelected: false,
      tobaccoValue: null,

      alcoholSelected: false,
      alcoholValue: null,

      overweightSelected: false,
      overweightValue: null,

      mentalSelected: false,
      mentalValue: null,

      modalDisplay: true
    }

    this.onClickCollapsible = this.onClickCollapsible.bind(this);
    this.indicatorClick = this.indicatorClick.bind(this);

    this.demoClick = this.demoClick.bind(this);
    this.demoValueChange = this.demoValueChange.bind(this);

    this.sedentaryClick = this.sedentaryClick.bind(this);
    this.sedentaryValueChange = this.sedentaryValueChange.bind(this);

    this.dietClick = this.dietClick.bind(this);
    this.dietValueChange = this.dietValueChange.bind(this);

    this.tobaccoClick = this.tobaccoClick.bind(this);
    this.tobaccoValueChange = this.tobaccoValueChange.bind(this);

    this.alcoholClick = this.alcoholClick.bind(this);
    this.alcoholValueChange = this.alcoholValueChange.bind(this);

    this.overweightClick = this.overweightClick.bind(this);
    this.overweightValueChange = this.overweightValueChange.bind(this);

    this.mentalClick = this.mentalClick.bind(this);
    this.mentalValueChange = this.mentalValueChange.bind(this);


  }

  componentWillMount(){
    var params = getParams()
    if(Object.keys(params).length !== 0){
      this.paramsInURL(params);
    }
  }

  paramsInURL( params ){
    this.setState({ modalDisplay: false });
    var indicator = params.indicator;
    this.setIndicator(indicator, params);

  }

  setIndicator( indicator, params ){
    var val = indicator.slice(0,2);
    if(val === 'de'){
      this.demoValueChange(indicator, params);
    } else if (val === 'se'){
      this.sedentaryValueChange(indicator, params);
    } else if (val === 'di'){
      this.dietValueChange(indicator, params);
    } else if (val === 'to'){
      this.tobaccoValueChange(indicator, params);
    } else if (val === 'al'){
      this.alcoholValueChange(indicator, params);
    } else if (val === 'ov'){
      this.overweightValueChange(indicator, params);
    } else if (val === 'me'){
      this.mentalValueChange(indicator, params);
    }
  }

  openCollapsibleAfterFetch(){
    var rthis = this;
    if(this.props.data.length === 0 || this.props.loading === true){
      setTimeout(function(){ rthis.openCollapsibleAfterFetch() }, 100)
    } else {
      setTimeout(function(){ rthis.setState({ collapsible: true }) }, 1000)
    }
  }

  demoClick(){
    var clicked = this.state.demographicSelected;
    this.setState({ demographicSelected: !clicked });
  }

  demoValueChange(val, params = {}){
    var rthis = this;
    var value = typeof(val) === 'object'? val.target.value: val;
      this.state.demoValue === value?this.setState({demoValue: null, demographicSelected: false }):(
        this.setState({
          demoValue: value,
          sedentaryValue: null,
          dietValue: null,
          tobaccoValue: null,
          alcoholValue: null,
          overweightValue: null,
          mentalValue: null
        }, () => {
          this.props.dispatch(value, params);
          setTimeout(function(){ rthis.openCollapsibleAfterFetch() }, 1000)
           }))
  }

 sedentaryClick(){
    var clicked = this.state.sedentarySelected;
    this.setState({ sedentarySelected: !clicked });
  }

  sedentaryValueChange(val, params = {}){
    var rthis = this;
    var value = typeof(val) === 'object'? val.target.value: val;
      this.state.sedentaryValue === value?this.setState({sedentaryValue: null, sedentarySelected: false }):(
        this.setState({
          sedentaryValue: value,
          demoValue: null,
          dietValue: null,
          tobaccoValue: null,
          alcoholValue: null,
          overweightValue: null,
          mentalValue: null
        }, () => {
          this.props.dispatch(value, params);
          setTimeout(function(){ rthis.openCollapsibleAfterFetch() }, 1000)
           }))
  }

  dietClick(){
     var clicked = this.state.dietSelected;
     this.setState({ dietSelected: !clicked});
   }

   dietValueChange(val, params = {}){
     var rthis = this;
     var value = typeof(val) === 'object'? val.target.value: val;
     this.state.dietValue === value?this.setState({dietValue: null, dietSelected: false }):(
       this.setState({
         dietValue: value,
         demoValue: null,
         sedentaryValue: null,
         tobaccoValue: null,
         alcoholValue: null,
         overweightValue: null,
         mentalValue: null
       }, () => {
         this.props.dispatch(value, params);
         setTimeout(function(){ rthis.openCollapsibleAfterFetch() }, 1000)
          }))
   }

   tobaccoClick(){
      var clicked = this.state.tobaccoSelected;
      this.setState({ tobaccoSelected: !clicked});
    }

    tobaccoValueChange(val, params = {}){
      var rthis = this;
      var value = typeof(val) === 'object'? val.target.value: val;
      this.state.tobaccoValue === value?this.setState({tobaccoValue: null, tobaccoSelected: false }):(
        this.setState({
          tobaccoValue: value,
          demoValue: null,
          sedentaryValue: null,
          dietValue: null,
          alcoholValue: null,
          overweightValue: null,
          mentalValue: null
        }, () => {
          this.props.dispatch(value, params);
          setTimeout(function(){ rthis.openCollapsibleAfterFetch() }, 1000)
           }))
    }

    alcoholClick(){
       var clicked = this.state.alcoholSelected;
       this.setState({ alcoholSelected: !clicked});
     }

     alcoholValueChange(val, params = {}){
       var rthis = this;
       var value = typeof(val) === 'object'? val.target.value: val;
       this.state.alcoholValue === value?this.setState({alcoholValue: null, alcoholSelected: false }):(
         this.setState({
           alcoholValue: value,
           demoValue: null,
           sedentaryValue: null,
           dietValue: null,
           tobaccoValue: null,
           overweightValue: null,
           mentalValue: null
         }, () => {
           this.props.dispatch(value, params);
           setTimeout(function(){ rthis.openCollapsibleAfterFetch() }, 1000)
            }))
     }

     overweightClick(){
        var clicked = this.state.overweightSelected;
        this.setState({ overweightSelected: !clicked});
      }

      overweightValueChange = (val, params = {}) => {
        console.log("overweightValueChange", val, "params", params)
        var rthis = this;
        var value = typeof(val) === 'object'? val.target.value: val;
        this.state.overweightValue === value?this.setState({overweightValue: null, overweightSelected: false }):(
          this.setState({
            overweightValue: value,
            demoValue: null,
            sedentaryValue: null,
            dietValue: null,
            tobaccoValue: null,
            alcoholValue: null,
            mentalValue: null
          }, () => {
            this.props.dispatch(value, params);
            setTimeout(function(){ rthis.openCollapsibleAfterFetch() }, 1000)
             }))
      }

      mentalClick(){
         var clicked = this.state.mentalSelected;
         this.setState({ mentalSelected: !clicked});
       }

       mentalValueChange(val, params = {}){
         var rthis = this;
         var value = typeof(val) === 'object'? val.target.value: val;
         this.state.mentalValue === val.target.value?this.setState({mentalValue: null, mentalSelected: false }):(
           this.setState({
             mentalValue: value,
             overweightValue: null,
             demoValue: null,
             sedentaryValue: null,
             dietValue: null,
             tobaccoValue: null,
             alcoholValue: null
           }, () => {
             this.props.dispatch(value,params);
             setTimeout(function(){ rthis.openCollapsibleAfterFetch() }, 1000)
              }))
       }

  indicatorClick(arr){
    this.setState({ indicatorMenu: arr })
  }


  onClickCollapsible(){
    let temp = this.state.collapsible;
    this.setState({ collapsible: !temp })
  }



  render() {
    const {
            demographicSelected, demoValue,
            sedentarySelected, sedentaryValue,
            dietSelected, dietValue,
            tobaccoSelected, tobaccoValue,
            alcoholSelected, alcoholValue,
            overweightSelected, overweightValue,
            mentalSelected, mentalValue,
            collapsible, modalDisplay
            } = this.state;

    const { countries, gender, age, yearBound, data, loading, url } = this.props;

    return (
      <div className="View">
        <div className="desktop">
          <Row>
            <Col s={4} className="logo-view">
              <a href="http://www.youthandncds.org/">
                <img alt="logo" src="logo.png" height="43" width="179"/>
              </a>
            </Col>
            <Col s={3} className="indicator-view">
              <IndicatorDropdown display={"desktop"}
                indicatorClick={this.indicatorClick}
                demoClick={this.demoClick}
                demographicSelected={demographicSelected}
                demoValue={demoValue}
                demoValueChange={this.demoValueChange}

                sedentaryClick={this.sedentaryClick}
                sedentarySelected={sedentarySelected}
                sedentaryValue={sedentaryValue}
                sedentaryValueChange={this.sedentaryValueChange}

                dietClick={this.dietClick}
                dietSelected={dietSelected}
                dietValue={dietValue}
                dietValueChange={this.dietValueChange}

                tobaccoClick={this.tobaccoClick}
                tobaccoSelected={tobaccoSelected}
                tobaccoValue={tobaccoValue}
                tobaccoValueChange={this.tobaccoValueChange}

                alcoholClick={this.alcoholClick}
                alcoholSelected={alcoholSelected}
                alcoholValue={alcoholValue}
                alcoholValueChange={this.alcoholValueChange}

                overweightClick={this.overweightClick}
                overweightSelected={overweightSelected}
                overweightValue={overweightValue}
                overweightValueChange={this.overweightValueChange}

                mentalClick={this.mentalClick}
                mentalSelected={mentalSelected}
                mentalValue={mentalValue}
                mentalValueChange={this.mentalValueChange}
              />
            </Col>
            <Col s={4} className="" style={{paddingTop: "36px"}}>
              {/* <CountrySelector onAddCountry={this.onAddCountry}/> */}
              <CountrySelector />
            </Col>
            <Col s={1} >
              <a className="microsite" href="http://www.youthandncds.org/home/">
                <span>Insights Feature</span>
                <Icon>arrow_forward</Icon>
              </a>
            </Col>
          </Row>
          {
            loading? <div class="loader-container"><div class="loader"></div></div>:(collapsible? <OpenCollapsible onClickCollapsible={this.onClickCollapsible}
                                                     />: <CloseCollapsible
                                                            onClickCollapsible={this.onClickCollapsible}/>)
          }
          </div>
          <div className="phone">
            <Row>
              <Col s={8} className="center">
                <img alt="logo" src="logo.png" height="43" width="179"/>
              </Col>
              <Col s={4} className="microsite">
                  Insights Feature
                  <Icon>arrow_forward</Icon>
              </Col>
            </Row>
            <Row>
              <IndicatorDropdown display={"phone"}
                indicatorClick={this.indicatorClick}
                demoClick={this.demoClick}
                demographicSelected={demographicSelected}
                demoValue={demoValue}
                demoValueChange={this.demoValueChange}

                sedentaryClick={this.sedentaryClick}
                sedentarySelected={sedentarySelected}
                sedentaryValue={sedentaryValue}
                sedentaryValueChange={this.sedentaryValueChange}

                dietClick={this.dietClick}
                dietSelected={dietSelected}
                dietValue={dietValue}
                dietValueChange={this.dietValueChange}

                tobaccoClick={this.tobaccoClick}
                tobaccoSelected={tobaccoSelected}
                tobaccoValue={tobaccoValue}
                tobaccoValueChange={this.tobaccoValueChange}

                alcoholClick={this.alcoholClick}
                alcoholSelected={alcoholSelected}
                alcoholValue={alcoholValue}
                alcoholValueChange={this.alcoholValueChange}

                overweightClick={this.overweightClick}
                overweightSelected={overweightSelected}
                overweightValue={overweightValue}
                overweightValueChange={this.overweightValueChange}

                mentalClick={this.mentalClick}
                mentalSelected={mentalSelected}
                mentalValue={mentalValue}
                mentalValueChange={this.mentalValueChange}
              />
            </Row>
            <Row className="center">
              <CountrySelector />
            </Row>
            <OpenCollapsible display={"phone"} />

          </div>
          <Row className="chart-container">
            <Row>
              <Col s={9} className="indicator-display">
                {
                  demoValue?<div>
                                <span style={{fontWeight: "bold"}}>{Indicator["demo"]} -</span>
                                {Indicator[demoValue]}&nbsp;&nbsp;
                                <div class="tooltip">
                                  <img style={{width: "15px", height: "15px"}} src="info-light.png" />
                                  <div class="tooltiptext">
                                    <span style={{fontWeight: "bold"}}>More Information - </span>
                                        {Indicator[`${demoValue}-i`]}
                                    </div>
                                 </div>
                            </div>:""
                }
                {
                  sedentaryValue?<div>
                                    <span style={{fontWeight: "bold"}}>{Indicator["sedentary"]} -</span>
                                    {Indicator[sedentaryValue]}&nbsp;&nbsp;
                                    <div class="tooltip">
                                      <img style={{width: "15px", height: "15px"}} src="info-light.png" />
                                      <div class="tooltiptext">
                                        <span style={{fontWeight: "bold"}}>More Information - </span>
                                            {Indicator[`${sedentaryValue}-i`]}
                                        </div>
                                     </div>
                                  </div>:""
                }
                {
                  dietValue?<div>
                              <span style={{fontWeight: "bold"}}>{Indicator["diet"]} -</span>
                                {Indicator[dietValue]}&nbsp;&nbsp;
                                <div class="tooltip">
                                  <img style={{width: "15px", height: "15px"}} src="info-light.png" />
                                  <div class="tooltiptext">
                                    <span style={{fontWeight: "bold"}}>More Information - </span>
                                        {Indicator[`${dietValue}-i`]}
                                    </div>
                                 </div>
                              </div>:""
                }
                {
                  tobaccoValue?<div>
                                <span style={{fontWeight: "bold"}}>{Indicator["tobacco"]} -</span>
                                  {Indicator[tobaccoValue]}&nbsp;&nbsp;
                                  <div class="tooltip">
                                    <img style={{width: "15px", height: "15px"}} src="info-light.png" />
                                    <div class="tooltiptext">
                                      <span style={{fontWeight: "bold"}}>More Information - </span>
                                          {Indicator[`${tobaccoValue}-i`]}
                                      </div>
                                   </div>
                                </div>:""
                }
                {
                  alcoholValue?<div>
                                <span style={{fontWeight: "bold"}}>{Indicator["alcohol"]} -</span>
                                  {Indicator[alcoholValue]}&nbsp;&nbsp;
                                  <div class="tooltip">
                                    <img style={{width: "15px", height: "15px"}} src="info-light.png" />
                                    <div class="tooltiptext">
                                      <span style={{fontWeight: "bold"}}>More Information - </span>
                                          {Indicator[`${alcoholValue}-i`]}
                                      </div>
                                   </div>
                                </div>:""
                }
                {
                  overweightValue?<div>
                                    <span style={{fontWeight: "bold"}}>{Indicator["overweight"]} -</span>
                                      {Indicator[overweightValue]}&nbsp;&nbsp;
                                      <div class="tooltip">
                                        <img style={{width: "15px", height: "15px"}} src="info-light.png" />
                                        <div class="tooltiptext">
                                          <span style={{fontWeight: "bold"}}>More Information - </span>
                                              {Indicator[`${overweightValue}-i`]}
                                          </div>
                                       </div>
                                    </div>:""
                }
                {
                  mentalValue?<div>
                                <span style={{fontWeight: "bold"}}>{Indicator["mental"]} -</span>
                                {Indicator[mentalValue]}&nbsp;&nbsp;
                                <div class="tooltip">
                                  <img style={{width: "15px", height: "15px"}} src="info-light.png" />
                                  <div class="tooltiptext">
                                    <span style={{fontWeight: "bold"}}>More Information - </span>
                                        {Indicator[`${mentalValue}-i`]}
                                    </div>
                                 </div>
                              </div>:""
                }
              </Col>
              <Col s={3} className="view-icons">
                {/* <div class="sharethis-inline-share-buttons"></div> */}
                <div data-url={url} data-title="Sharing" data-network="linkedin" class="st-custom-button"><img alt="linkedin" src="linkedin.png" height="32" width="32"/></div>
                &nbsp;&nbsp;
                <div data-url={url} data-title="Sharing" data-network="twitter" class="st-custom-button"><img alt="twitter" src="twitter.png" height="32" width="32"/></div>
                &nbsp;&nbsp;
                <div data-url={url} data-title="Sharing" data-title="Sharing"data-network="facebook" class="st-custom-button"><img alt="facebook" src="facebook.png" height="32" width="32"/></div>
                &nbsp;&nbsp;
                <div data-url={url} data-title="Sharing" data-network="facebook" class="st-custom-button"><img src="robot.png" height="32" width="32"/></div>




                  {/* <img alt="linkedin" src="linkedin.png" height="32" width="32"/>
                  &nbsp;&nbsp;
                  <img alt="twitter" src="twitter.png" height="32" width="32"/>
                  &nbsp;&nbsp;
                  <img alt="facebook" src="facebook.png" height="32" width="32"/>
                  &nbsp;&nbsp;
                  <img src="robot.png" height="32" width="32"/> */}
              </Col>
            </Row>
            <Col s={12}>
              <MapViewCollapsible />
            </Col>
            <Col s={12}>
              <BarChartCollapsible />
            </Col>
            <Col s={12}>
              <LineChartCollapsible />
            </Col>
            <Col s={12}>
              <TableCollapsible />
            </Col>
            {/* <Col s={12}>
              <CountrySourcesCollapsible />
            </Col> */}
            <Col s={12}>
              <SourcesCollapsible indicatorValue={demoValue?demoValue:
                                                    sedentaryValue? sedentaryValue:
                                                      dietValue? dietValue:
                                                        tobaccoValue? tobaccoValue:
                                                          alcoholValue? alcoholValue:
                                                            overweightValue? overweightValue: mentalValue}/>
            </Col>
          </Row>
          <div className="indicator-modal">
            <IndicatorModal
              demoClick={this.demoClick}
              demographicSelected={demographicSelected}
              demoValue={demoValue}
              demoValueChange={this.demoValueChange}

              sedentaryClick={this.sedentaryClick}
              sedentarySelected={sedentarySelected}
              sedentaryValue={sedentaryValue}
              sedentaryValueChange={this.sedentaryValueChange}

              dietClick={this.dietClick}
              dietSelected={dietSelected}
              dietValue={dietValue}
              dietValueChange={this.dietValueChange}

              tobaccoClick={this.tobaccoClick}
              tobaccoSelected={tobaccoSelected}
              tobaccoValue={tobaccoValue}
              tobaccoValueChange={this.tobaccoValueChange}

              alcoholClick={this.alcoholClick}
              alcoholSelected={alcoholSelected}
              alcoholValue={alcoholValue}
              alcoholValueChange={this.alcoholValueChange}

              overweightClick={this.overweightClick}
              overweightSelected={overweightSelected}
              overweightValue={overweightValue}
              overweightValueChange={this.overweightValueChange}

              mentalClick={this.mentalClick}
              mentalSelected={mentalSelected}
              mentalValue={mentalValue}
              mentalValueChange={this.mentalValueChange}

              countries={countries}
              modalDisplay = {modalDisplay}
              />
          </div>
          <Footer />
      </div>
    );
  }
}

function mapStateToProps(state){
  return {
    data: state.data,
    countries: state.countries,
    gender: state.gender,
    age: state.age,
    yearBound: state.yearBound,
    loading: state.loading,
    error: state.error,
    url: state.url
  }
};

function mapDispatchToProps(dispatch){
  return {
    addCountry: (country) => dispatch({ type: 'ADDCOUNTRY', value: country }),
    dispatch: (indicator, params) => dispatch(fetchData(indicator, params))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./src/components/View.js